import { createClient } from 'contentful'

const client = createClient({
  space: process.env.VUE_APP_CONTENTFUL_SPACE_ID,
  environment: process.env.VUE_APP_CONTENTFUL_ENVIRONMENT,
  accessToken: process.env.VUE_APP_CONTENTFUL_ACCESS_TOKEN
})

export default {
  namespaced: true,
  state: {
    categories: [],
    products: [],
    tags: [],
    tagsParents: [],
    blogPosts: [],
    requests: [],
    events: [],
    fullScreenGalleries: [],
    singlePages: []
  },
  getters: {
    categories: state => state.categories,
    category: state => slug => state.categories.find(category => category.fields.slug === slug),
    products: state => state.products,
    product: state => slug => state.products.find(product => product.fields.slug === slug),
    tags: state => state.tags,
    tagsParents: state => state.tagsParents,
    tag: state => slug => state.tags.find(tag => tag.fields.slug === slug),
    blogPosts: state => state.blogPosts,
    blogPost: state => slug => state.blogPosts.find(blogPost => blogPost.fields.slug === slug),
    requests: state => state.requests,
    events: state => state.events,
    fullScreenGalleries: state => state.fullScreenGalleries,
    singlePages: state => state.singlePages,
    singlePage: state => slug => state.singlePages.find(singlePage => singlePage.fields.slug === slug)
  },
  mutations: {
    updateCategories (state, categories) {
      state.categories = categories
    },
    updateProducts (state, products) {
      state.products = products
    },
    updateTags (state, tags) {
      state.tags = tags
    },
    updateTagsParents (state, tagsParents) {
      state.tagsParents = tagsParents
    },
    updateBlogPosts (state, blogPosts) {
      state.blogPosts = blogPosts
    },
    updateRequests (state, requests) {
      state.requests = requests
    },
    updateEvents (state, events) {
      state.events = events
    },
    updateFullScreenGalleries (state, fullScreenGalleries) {
      state.fullScreenGalleries = fullScreenGalleries
    },
    updateSinglePages (state, singlePages) {
      state.singlePages = singlePages
    }
  },
  actions: {
    async loadCategories ({ commit, rootState }) {
      const entries = await client.getEntries({
        content_type: 'category',
        locale: rootState.contentfulLangMap[rootState.lang],
        order: 'fields.order'
      })

      commit('updateCategories', entries.items)
    },
    async loadProducts ({ commit, rootState }) {
      const entries = await client.getEntries({
        content_type: 'products',
        locale: rootState.contentfulLangMap[rootState.lang],
        order: 'fields.order',
        limit: 900
      })

      commit('updateProducts', entries.items)
    },
    async loadTags ({ commit, rootState }) {
      const entries = await client.getEntries({
        content_type: 'tags',
        locale: rootState.contentfulLangMap[rootState.lang]
      })

      commit('updateTags', entries.items)
    },
    async loadTagsParents ({ commit, rootState }) {
      const entries = await client.getEntries({
        content_type: 'tagsParent',
        locale: rootState.contentfulLangMap[rootState.lang]
      })

      commit('updateTagsParents', entries.items)
    },
    async loadBlogPosts ({ commit, rootState }) {
      const entries = await client.getEntries({
        content_type: 'posts',
        locale: rootState.contentfulLangMap[rootState.lang]
      })

      commit('updateBlogPosts', entries.items)
    },
    async loadRequests ({ commit, rootState }) {
      const requests = await client.getEntries({
        content_type: 'requests',
        locale: rootState.contentfulLangMap[rootState.lang]
      })

      commit('updateRequests', requests.items)
    },
    async loadEvents ({ commit, rootState }) {
      const entries = await client.getEntries({
        content_type: 'events',
        locale: rootState.contentfulLangMap[rootState.lang]
      })

      commit('updateEvents', entries.items)
    },
    async loadFullScreenGalleries ({ commit, rootState }) {
      const entries = await client.getEntries({
        content_type: 'fullScreenGallery',
        locale: rootState.contentfulLangMap[rootState.lang],
        order: 'fields.order'
      })

      commit('updateFullScreenGalleries', entries.items)
    },
    async loadSinglePages ({ commit, rootState }) {
      const entries = await client.getEntries({
        content_type: 'singlePages',
        locale: rootState.contentfulLangMap[rootState.lang]
      })
      commit('updateSinglePages', entries.items)
    }
  }
}
